<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <!-- <button v-on:click="onCreate()" class="btn btn-primary">Create</button> -->
          </div>           
          <div class="col-md-6">
            <div class="row" style="margin-right:0px;margin-bottom:5px;">
              <div class="col-sm-3 col-md-3">
                <div class="form-inline">
                  <label for="pagesize">Show</label>                    
                  <select id="pagesize" @change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>                   
                </div>
              </div>               
              <div class="col-sm-9 col-md-9 has-feedback">
                <div class="row">
                  <input type="text" class="form-control" v-on:keyup.enter="onSearch($event)" placeholder="Search by POS name">
                  <span class="icon ion-search form-control-feedback"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="o_kanban_view o_kanban_dashboard o_pos_kanban o_kanban_ungrouped">
        <div class="o_kanban_record" v-for="(row, i) in listData" v-bind:key="i">
          <!-- Kanban Header -->
          <div class="o_kanban_card_header">
            <div class="o_kanban_card_header_title mb16">
              <div class="o_primary">
                {{ row.name }}
              </div>                                                                        
              <div class="o_secondary mt16">
                {{ row.usedByCashierId == 0 ? 'Unused' : row.usedByCashierName }}
              </div>
            </div>
          </div>
          <!-- Kanban Content -->
          <div class="container o_kanban_card_content">
            <div class="row">
              <div class="col-xs-6 o_kanban_primary_left">
                <button v-if="row.status == SESSION_NEW" class="btn btn-primary oe_kanban_action oe_kanban_action_button" @click="onNewSession(row)">New Session</button>
                <button v-if="row.status == SESSION_INPROGRESS" class="btn btn-primary oe_kanban_action oe_kanban_action_button" @click="onResume(row)">Resume</button>
              </div>
              <div class="col-xs-6 o_kanban_primary_right">
              </div>
            </div>
          </div>
          <!-- Kanban dropdown setting -->
          <div class="o_dropdown_kanban dropdown">
            <a class="dropdown-toggle btn" data-toggle="dropdown" href="#" aria-expanded="true">
                <span class="icon ion-more" aria-hidden="true"></span>
            </a>
            <ul class="dropdown-menu" role="menu" aria-labelledby="dLabel">
              <li><a href="#" class=" oe_kanban_action oe_kanban_action_a" @click="gotoSession(row)">Session</a></li>
              <li><a href="#" class=" oe_kanban_action oe_kanban_action_a" @click="gotoPOSSetting(row)">Setting</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row pull-right">
          <div class="form-group">
            <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
            </label>
            <label>
                Page
            </label>
            <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
            </label>
            <label id="TotalPageText">
              {{ totalPages }}                
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
            </label>
            <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
            </label>
          </div>
        </div> 
      </div>
    </div>
  </div>    
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import store from '../../store'
// import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const SESSION_NEW = 'New'
const SESSION_INPROGRESS = 'InProgress'
const MODE_VIEW = 'read'

export default {
  name: 'POSDashboard',
  components: {
    // datepicker
  },
  data() {
    return {
      // DATE_FORMAT: config.dateFormat,
      SESSION_NEW: SESSION_NEW,
      SESSION_INPROGRESS: SESSION_INPROGRESS,
      MODE_VIEW: MODE_VIEW,
      listData: null,
      listDataTemp: null,
      listCashier: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      openingBalance: 0,
      screenDetails: null
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    gotoSession(row) {
      let params = {
        id: row.sessionId,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'POS Session', params: params })
    },
    inquiry() {
      api
        .request('POS', 'get', '/api/POS/InquiryDashboard', null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize

          // Populate Cashier & Project
          var arrCashier = []
          var arrProject = []
          this.listDataTemp.forEach(itemPOS => {
            arrCashier.push(itemPOS.usedByCashierId)
            var arrCashierUnique = arrCashier.filter(function(item, index) {
              return arrCashier.indexOf(item) >= index
            })
            arrCashier = arrCashierUnique

            arrProject.push(itemPOS.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique
          })

          this.getCashierName(arrCashier, arrProject)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCashierName(arrCashier, arrProject) {
      let whereClause = 'id in (' + arrCashier.join(',') + ')'
      api
        .request('Account', 'get', '/api/Account/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCashier.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCashier = data.entity

          var cashierName
          this.listDataTemp.forEach(itemPOS => {
            cashierName = ''
            this.listCashier.some(function(item, index) {
              if (itemPOS.usedByCashierId === item.id) {
                cashierName = item.name
              }
            })
            itemPOS.usedByCashierName = cashierName
          })
          this.getProjectName(arrProject)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProjectName(arrProject) {
      let whereClause = 'id in (' + arrProject.join(',') + ')'
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          let data = response.data
          this.listProject = data.entity

          let projectName
          let projectImageUrl
          this.listDataTemp.forEach(itemPOS => {
            projectName = ''
            projectImageUrl = ''
            this.listProject.some(function(item, index) {
              if (itemPOS.projectId === item.id) {
                projectName = item.name
                projectImageUrl = item.imageUrl
              }
            })
            itemPOS.projectName = projectName
            itemPOS.projectImageUrl = projectImageUrl
          })
          this.listData = this.listDataTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onNewSession(row) {
      this.getIPAddress()
        .then((response) => {
          if (response && response !== '') {
            this.createNewSession(row, response)
          }
        })
    },
    createNewSession(row, ipAddress) {
      if (!ipAddress || ipAddress === '') {
        SweetAlert.fire('Checking IP Address', 'Can\'t get IP Address of this machine', 'error')
        return
      }

      var reqData = {
        Id: row.pointOfSalesId,
        Name: row.name,
        IsBarRestaurant: row.isBarRestaurant,
        ProjectId: row.projectId,
        LocationId: ipAddress
      }

      api
        .request('POS', 'post', '/api/POS/CreateSession', reqData)
        .then(response => {
          if (response.data.returnStatus) {
            this.showPOS(response.data.entity.sessionId, response.data.entity.sessionName,
                         response.data.entity.usedByCashierId, store.getters.user.name, row.projectId, row.projectName, response.data.entity.pointOfSalesId,
                         response.data.entity.loginSeqNo)
            this.showPOSCustomer(response.data.entity.sessionId)
          } else {
            var message = response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onResume(row) {
      this.getIPAddress()
        .then((response) => {
          // console.log(response)
          if (response && response !== '') {
            this.resumeSession(row, response)
          }
        })
    },
    resumeSession(row, ipAddress) {
    //   if (store.getters.user.id !== row.usedByCashierId) {
    //     SweetAlert.fire('POS Session', 'This POS session already used by ' + row.usedByCashierName + ' on machine: ' + row.locationId, 'warning')
    //     return
    //   }
    //   if (row.locationId !== ipAddress) {
    //     alert(ipAddress)
    //     SweetAlert.fire('POS Session', 'This POS session already used by you on machine: ' + row.locationId, 'warning')
    //     return
    //   }
      this.showPOS(row.sessionId, row.sessionName, row.usedByCashierId, row.usedByCashierName, row.projectId, row.projectName, row.projectImageUrl, row.pointOfSalesId, row.loginSeqNo)
      this.showPOSCustomer(row.sessionId)
    },
    showPOS(sessionId, sessionName, cashierId, cashierName, projectId, projectName, projectImageUrl, pointOfSalesId, loginSeqNo) {
      let params = {
        sessionId: sessionId,
        sessionName: sessionName,
        cashierId: cashierId,
        cashierName: cashierName,
        projectId: projectId,
        projectName: projectName,
        projectImageUrl: projectImageUrl,
        pointOfSalesId: pointOfSalesId,
        loginSeqNo: loginSeqNo
      }
      this.$router.push({ name: 'PoS', params: params }) // https://stackoverflow.com/questions/35664550/vue-js-redirection-to-another-page
    },
    async showPOSCustomer(sessionId) {
      if (!config.isDualScreen) {
        return
      }
      // extended screen
      // https://developer.chrome.com/docs/capabilities/web-apis/window-management
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/open
      let screenDetails = await window.getScreenDetails()
      let customerScreen

      if (window.screen.isExtended && screenDetails.screens.length > 1) {
        customerScreen = screenDetails.screens[1]
      } else {
        customerScreen = screenDetails.screens[0]
      }

      let windowWidth = customerScreen.availWidth
      let windowHeight = customerScreen.availHeight
      let leftExtendedScreen = customerScreen.left
      let topExtendedScreen = customerScreen.top
      let xPosition = leftExtendedScreen // + (customerScreen.width / 2) - (windowWidth / 2)
      let yPosition = topExtendedScreen // + (customerScreen.height / 2) - (windowHeight / 2)

      const qrisWindow = window.open('/pos-customer?sessionId=' + sessionId + '&qrData=', 'POSCustomer', 'toolbar=no,scrollbars=no,resizable=no,width=' + windowWidth + ',height=' + windowHeight)
      qrisWindow.moveTo(xPosition, yPosition)
    },
    getIPAddress() {
      // https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript
      return new Promise((resolve, reject) => {
        var w = window
        var a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
          iceServers: []
        })
        var b = () => {}
        a.createDataChannel('')
        a.createOffer(c => a.setLocalDescription(c, b, b), b)
        a.onicecandidate = c => {
          try {
            if (c.candidate) {
              // console.log(c.candidate)
              // console.log(c)
              resolve(c.candidate.address)
            }
          } catch (e) {
          }
        }
      })
    }
  }
}
</script>

<style scoped>
/* Kanban View */
.o_kanban_view {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-align-content: stretch;
    align-content: stretch;
    overflow-x: visible;
}

@media (max-width: 767px) {
    .o_kanban_view {
        padding: 0px!important;
        overflow-x: auto;
    }
}

.o_kanban_view .o_kanban_record,
.o_kanban_view .o_kanban_quick_create {
    padding: 8px 8px;
    border: 1px solid #E5E5E5;
    background-color: white;
}

@media (max-width: 767px) {
    .o_kanban_view .o_kanban_record,
    .o_kanban_view .o_kanban_quick_create {
        padding: 8px 16px;
    }
}

.o_kanban_view .o_kanban_quick_create {
    box-shadow: 0 0 20px -10px;
    margin: 0 8px -1px 8px;
}

.o_kanban_view .o_kanban_quick_create input {
    width: 100%;
    margin: 2px 0 8px;
    padding: 3px 6px;
    color: inherit;
    font-weight: 500;
}

.o_kanban_view .o_kanban_record {
    position: relative;
    display: inline-block;
    border-color: #d9d7d7;
    min-width: 150px;
    margin: 0 0 -1px;
}

.o_kanban_view .o_kanban_record::after {
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    bottom: 0;
    right: auto;
    width: 3px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_top,
.o_kanban_view .o_kanban_record .o_kanban_record_body {
    margin-bottom: 5px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_top,
.o_kanban_view .o_kanban_record .o_kanban_record_bottom {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
}

.o_kanban_view .o_kanban_record .o_kanban_record_top {
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.o_kanban_view .o_kanban_record .o_kanban_record_top .o_dropdown_kanban {
    position: relative;
    top: auto;
    right: auto;
}

.o_kanban_view .o_kanban_record .o_kanban_record_top .o_kanban_record_headings {
    line-height: 1.2;
    -ms-flex: 1 1 auto;
    -moz-flex: 1 1 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    word-wrap: break-word;
    overflow: hidden;
}

.o_kanban_view .o_kanban_record .o_kanban_record_title {
    color: inherit;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0;
}

.o_kanban_view .o_kanban_record .o_kanban_record_subtitle {
    display: block;
    margin-top: 2.5px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_left,
.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_right {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    height: 20px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_left {
    -ms-flex: 1 1 auto;
    -moz-flex: 1 1 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_left > * {
    margin-right: 6px;
    line-height: 1;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_left .o_priority_star {
    margin-top: 1px;
    font-size: 18px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_right {
    -ms-flex: 0 1 auto;
    -moz-flex: 0 1 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 1 auto;
    flex: 0 1 auto;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .oe_kanban_bottom_right .oe_kanban_avatar {
    width: 20px;
    height: 20px;
    margin-left: 6px;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .o_link_muted {
    color: #666;
}

.o_kanban_view .o_kanban_record .o_kanban_record_bottom .o_link_muted:hover {
    color: #337AB7;
    text-decoration: underline;
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban,
.o_kanban_view .o_kanban_record .o_dropdown_kanban {
    position: absolute;
    top: 8px;
    left: auto;
    bottom: auto;
    right: 8px;
    visibility: hidden;
}

@media (max-width: 767px) {
    .o_kanban_view .oe_kanban_card .o_dropdown_kanban,
    .o_kanban_view .o_kanban_record .o_dropdown_kanban {
        visibility: visible;
    }
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-toggle,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-toggle {
    margin: -1px -1px auto auto;
    padding: 4px 8px;
    border: 1px solid transparent;
    border-bottom: none;
    vertical-align: top;
    color: #666;
    margin: -9px -9px 0 0;
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-toggle:hover,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-toggle:hover {
    color: inherit;
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-toggle:focus,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-toggle:focus,
.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-toggle:active,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-toggle:active,
.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-toggle:focus:active,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-toggle:focus:active {
    outline: none;
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban.open .dropdown-toggle,
.o_kanban_view .o_kanban_record .o_dropdown_kanban.open .dropdown-toggle {
    position: relative;
    background: white;
    border-color: #d9d7d7;
    z-index: 1001;
}

.o_kanban_view .oe_kanban_card .o_dropdown_kanban .dropdown-menu,
.o_kanban_view .o_kanban_record .o_dropdown_kanban .dropdown-menu {
    position: absolute;
    top: auto;
    left: auto;
    bottom: auto;
    right: -1px;
    margin-top: -1px;
    border-color: #d9d7d7;
    right: -9px;
}

.o_kanban_view .oe_kanban_card:hover .o_dropdown_kanban,
.o_kanban_view .o_kanban_record:hover .o_dropdown_kanban,
.o_kanban_view .oe_kanban_card .o_dropdown_kanban.open,
.o_kanban_view .o_kanban_record .o_dropdown_kanban.open {
    visibility: visible;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker {
    max-width: 150px;
    padding: 3px 15px 3px 20px;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li {
    display: inline-block;
    margin: 5px 5px 0 0;
    border: 1px solid white;
    box-shadow: 0 0 0 1px #E5E5E5;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li > a,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li > a {
    display: block;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li > a::after,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li > a::after {
    content: "";
    display: block;
    width: 20px;
    height: 15px;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li:first-child > a,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li:first-child > a {
    position: relative;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li:first-child > a::before,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li:first-child > a::before {
    content: "";
    position: absolute;
    top: -2px;
    left: 10px;
    bottom: auto;
    right: auto;
    display: block;
    width: 1px;
    height: 20px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: red;
}

.o_kanban_view .oe_kanban_card .oe_kanban_colorpicker > li:first-child > a::after,
.o_kanban_view .o_kanban_record .oe_kanban_colorpicker > li:first-child > a::after {
    background-color: white;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags,
.o_kanban_view .o_kanban_record .o_field_many2manytags,
.o_kanban_view .oe_kanban_card .o_kanban_tags,
.o_kanban_view .o_kanban_record .o_kanban_tags {
    display: block;
    margin-bottom: 5px;
    line-height: 1.2;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag {
    display: inline-block;
    margin-right: 4px;
    font-size: 11px;
    font-weight: 500;
    background-color: transparent;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_0 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_0 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_0 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_0 span {
    background-color: #AEA79F;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_1 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_1 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_1 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_1 span {
    background-color: #F06050;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_2 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_2 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_2 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_2 span {
    background-color: #F4A460;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_3 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_3 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_3 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_3 span {
    background-color: #F7CD1F;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_4 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_4 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_4 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_4 span {
    background-color: #6CC1ED;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_5 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_5 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_5 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_5 span {
    background-color: #814968;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_6 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_6 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_6 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_6 span {
    background-color: #EB7E7F;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_7 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_7 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_7 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_7 span {
    background-color: #2C8397;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_8 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_8 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_8 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_8 span {
    background-color: #475577;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_9 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_9 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_9 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_9 span {
    background-color: #D6145F;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_10 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_10 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_10 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_10 span {
    background-color: #30C381;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag.o_tag_color_11 span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag.o_tag_color_11 span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag.o_tag_color_11 span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag.o_tag_color_11 span {
    background-color: #9365B8;
}

.o_kanban_view .oe_kanban_card .o_field_many2manytags .o_tag span,
.o_kanban_view .o_kanban_record .o_field_many2manytags .o_tag span,
.o_kanban_view .oe_kanban_card .o_kanban_tags .o_tag span,
.o_kanban_view .o_kanban_record .o_kanban_tags .o_tag span {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 4px;
    border-radius: 100%;
}

.o_kanban_view .oe_kanban_card .o_kanban_image,
.o_kanban_view .o_kanban_record .o_kanban_image {
    text-align: center;
}

.o_kanban_view .oe_kanban_card .o_kanban_image img,
.o_kanban_view .o_kanban_record .o_kanban_image img {
    max-width: 100%;
}

.o_kanban_view .oe_kanban_card .o_kanban_button,
.o_kanban_view .o_kanban_record .o_kanban_button {
    margin-top: 15px;
}

.o_kanban_view .oe_kanban_card .o_kanban_button > button,
.o_kanban_view .o_kanban_record .o_kanban_button > button,
.o_kanban_view .oe_kanban_card .o_kanban_button > a,
.o_kanban_view .o_kanban_record .o_kanban_button > a {
    position: absolute;
    top: auto;
    left: auto;
    bottom: 8px;
    right: 8px;
}

@media (max-width: 767px) {
    .o_kanban_view .oe_kanban_card .o_kanban_button > button,
    .o_kanban_view .o_kanban_record .o_kanban_button > button,
    .o_kanban_view .oe_kanban_card .o_kanban_button > a,
    .o_kanban_view .o_kanban_record .o_kanban_button > a {
        right: 16px;
    }
}

.o_kanban_view .oe_kanban_card.oe_kanban_global_click,
.o_kanban_view .o_kanban_record.oe_kanban_global_click,
.o_kanban_view .oe_kanban_card.oe_kanban_global_click_edit,
.o_kanban_view .o_kanban_record.oe_kanban_global_click_edit {
    cursor: pointer;
}

.o_kanban_view .oe_kanban_card.ui-sortable-helper,
.o_kanban_view .o_kanban_record.ui-sortable-helper {
    -webkit-transform: rotate(-3deg);
    -moz-transform: rotate(-3deg);
    -ms-transform: rotate(-3deg);
    -o-transform: rotate(-3deg);
    transform: rotate(-3deg);
    box-shadow: 0 5px 25px -10px black;
    -webkit-transition: transform 0.6s, box-shadow 0.3s;
    -o-transition: transform 0.6s, box-shadow 0.3s;
    transition: transform 0.6s, box-shadow 0.3s;
}

.o_kanban_view .oe_kanban_card .o_attachment_image > img,
.o_kanban_view .o_kanban_record .o_attachment_image > img {
    width: 100%;
    height: auto;
    margin-bottom: 5px;
}

.o_kanban_view .oe_kanban_card .o_progressbar,
.o_kanban_view .o_kanban_record .o_progressbar {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    height: 20px;
}

.o_kanban_view .oe_kanban_card .o_progressbar .o_progressbar_title,
.o_kanban_view .o_kanban_record .o_progressbar .o_progressbar_title {
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
}

.o_kanban_view .oe_kanban_card .o_progressbar .o_progress,
.o_kanban_view .o_kanban_record .o_progressbar .o_progress {
    -ms-flex: 1 1 auto;
    -moz-flex: 1 1 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    margin-top: 3px;
}

.o_kanban_view .oe_kanban_card .o_progressbar .o_progressbar_value,
.o_kanban_view .o_kanban_record .o_progressbar .o_progressbar_value {
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    height: 100%;
    text-align: right;
}

.o_kanban_view .oe_kanban_card .o_progressbar input.o_progressbar_value,
.o_kanban_view .o_kanban_record .o_progressbar input.o_progressbar_value {
    width: 15%;
    margin-left: 8px;
}

.o_kanban_view .oe_kanban_card .o_kanban_image,
.o_kanban_view .o_kanban_record .o_kanban_image {
    float: left;
    width: 64px;
}

.o_kanban_view .oe_kanban_card .o_kanban_image + div,
.o_kanban_view .o_kanban_record .o_kanban_image + div {
    padding-left: 72px;
}

@media (max-width: 767px) {
    .o_kanban_view .oe_kanban_card .o_kanban_image + div,
    .o_kanban_view .o_kanban_record .o_kanban_image + div {
        padding-left: 80px;
    }
}

.o_kanban_view .oe_kanban_card .oe_kanban_details,
.o_kanban_view .o_kanban_record .oe_kanban_details {
    width: 100%;
}

.o_kanban_view .oe_kanban_card .oe_kanban_details ul,
.o_kanban_view .o_kanban_record .oe_kanban_details ul {
    margin-bottom: 2.5px;
    padding-left: 0;
    list-style: none;
    font-size: 12px;
}

.o_kanban_view .oe_kanban_card .oe_kanban_details ul li,
.o_kanban_view .o_kanban_record .oe_kanban_details ul li {
    margin-bottom: 2px;
}

.o_kanban_view .oe_kanban_card .o_kanban_footer,
.o_kanban_view .o_kanban_record .o_kanban_footer {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.o_kanban_view .oe_kanban_card .o_kanban_footer > *,
.o_kanban_view .o_kanban_record .o_kanban_footer > * {
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
}

.o_kanban_view .oe_kanban_card .oe_kanban_text_red,
.o_kanban_view .o_kanban_record .oe_kanban_text_red {
    color: #A61300;
    font-weight: bold;
}

.o_kanban_view .oe_kanban_card .o_text_bold,
.o_kanban_view .o_kanban_record .o_text_bold {
    font-weight: bold;
}

.o_kanban_view .oe_kanban_card .o_text_block,
.o_kanban_view .o_kanban_record .o_text_block {
    display: block;
}

.o_kanban_view.o_kanban_grouped {
    min-height: 100%;
    padding: 0;
    background-color: #eeeeee;
}

.o_kanban_view.o_kanban_grouped .o_kanban_record,
.o_kanban_view.o_kanban_grouped .o_kanban_quick_create {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.o_kanban_view.o_kanban_grouped.o_kanban_small_column .o_kanban_group:not(.o_column_folded) {
    width: 272px;
}

.o_kanban_view .o_kanban_group {
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    padding: 0 32px 16px 16px;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    height: 50px;
    line-height: 2.2;
    color: inherit;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_column_title {
    -ms-flex: 1 1 auto;
    -moz-flex: 1 1 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    font-size: 16px;
    font-weight: 500;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_column_unfold {
    display: none;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_quick_add i {
    display: block;
    line-height: 50px;
    text-align: center;
    color: #4c4c4c;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.5;
    margin-left: 16px;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_quick_add i:hover,
.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_quick_add i:focus,
.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_quick_add i.focus {
    opacity: 1;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title:hover .o_kanban_config,
.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config.open {
    visibility: visible;
    margin-left: 8px;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config {
    visibility: hidden;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config i {
    display: block;
    line-height: 50px;
    text-align: center;
    color: #4c4c4c;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.5;
}

.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config i:hover,
.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config i:focus,
.o_kanban_view .o_kanban_group .o_kanban_header > .o_kanban_header_title .o_kanban_config i.focus {
    opacity: 1;
}

.o_kanban_view .o_kanban_group .o_kanban_load_more {
    padding: 8px 0;
    box-shadow: inset 0 10px 13px -13px black;
    text-align: center;
}

.o_kanban_view .o_kanban_group.ui-sortable-helper {
    box-shadow: 0 0 30px -10px black;
}

.o_kanban_view .o_kanban_group:not(.o_column_folded) {
    width: 332px;
}

.o_kanban_view .o_kanban_group.o_kanban_dragged {
    background-color: #4c4c4c;
}

.o_kanban_view .o_kanban_group.o_kanban_dragged .o_kanban_record {
    visibility: hidden;
}

.o_kanban_view.ui-sortable .o_kanban_header_title {
    cursor: move;
}

.o_kanban_view .o_kanban_group.o_column_folded {
    position: relative;
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    margin: 0;
    padding: 0 11px;
    cursor: pointer;
    background-color: #E5E5E5;
}

.o_kanban_view .o_kanban_group.o_column_folded + .o_kanban_group.o_column_folded {
    margin-left: 1px;
}

.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title {
    position: relative;
    opacity: 0.5;
}

.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title .o_column_title {
    position: absolute;
    top: 16px;
    left: -10px;
    bottom: auto;
    right: auto;
    -ms-transform-origin: left bottom 0;
    -webkit-transform-origin: left bottom 0;
    -moz-transform-origin: left bottom 0;
    transform-origin: left bottom 0;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    overflow: visible;
    white-space: nowrap;
    font-size: 15px;
}

.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title .o_column_unfold {
    display: block;
    line-height: 50px;
    text-align: center;
    color: #4c4c4c;
    font-size: 12px;
    cursor: pointer;
    opacity: 1;
}

.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title .o_column_unfold:hover,
.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title .o_column_unfold:focus,
.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_header_title .o_column_unfold.focus {
    opacity: 1;
}

.o_kanban_view .o_kanban_group.o_column_folded > .o_kanban_record,
.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_quick_add,
.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_config,
.o_kanban_view .o_kanban_group.o_column_folded .o_kanban_load_more {
    display: none!important;
}

.o_kanban_view .o_kanban_group.o_column_folded:hover .o_kanban_header_title,
.o_kanban_view .o_kanban_group.o_column_folded.o_kanban_hover .o_kanban_header_title {
    opacity: 1;
}

.o_kanban_view .o_column_quick_create {
    position: relative;
    -ms-flex: 0 0 auto;
    -moz-flex: 0 0 auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    margin: 0;
    padding: 0 11px;
    cursor: pointer;
}

.o_kanban_view .o_column_quick_create .o_column_header {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    height: 50px;
    line-height: 2.2;
    color: inherit;
    position: relative;
    opacity: 0.5;
}

.o_kanban_view .o_column_quick_create .o_column_header .o_kanban_title {
    position: absolute;
    top: 16px;
    left: -10px;
    bottom: auto;
    right: auto;
    -ms-transform-origin: left bottom 0;
    -webkit-transform-origin: left bottom 0;
    -moz-transform-origin: left bottom 0;
    transform-origin: left bottom 0;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    overflow: visible;
    white-space: nowrap;
    font-size: 15px;
}

.o_kanban_view .o_column_quick_create .o_column_header .o_kanban_add_column {
    display: block;
    line-height: 50px;
    text-align: center;
    color: #4c4c4c;
    font-size: 12px;
    cursor: pointer;
    opacity: 1;
}

.o_kanban_view .o_column_quick_create .o_column_header .o_kanban_add_column:hover,
.o_kanban_view .o_column_quick_create .o_column_header .o_kanban_add_column:focus,
.o_kanban_view .o_column_quick_create .o_column_header .o_kanban_add_column.focus {
    opacity: 1;
}

.o_kanban_view .o_column_quick_create .o_kanban_quick_create {
    display: none;
    width: 300px;
    height: 100%;
    margin: 0 -8px;
    border: none;
    box-shadow: 0 0 20px -10px;
    background-color: #eeeeee;
}

.o_kanban_view .o_column_quick_create .o_kanban_quick_create input,
.o_kanban_view .o_column_quick_create .o_kanban_quick_create input:focus,
.o_kanban_view .o_column_quick_create .o_kanban_quick_create input:hover {
    font-size: 16px;
    background: #eeeeee;
    outline: none;
    box-shadow: none;
    font-weight: 400;
    margin: 0;
}

.o_kanban_view .o_column_quick_create:hover .o_column_header,
.o_kanban_view .o_column_quick_create:hover .o_kanban_add_column {
    opacity: 1;
}

.o_kanban_view.o_kanban_ungrouped {
    -ms-flex-flow: row wrap;
    -moz-flex-flow: row wrap;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
    -moz-justify-content: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    padding: 8px 8px;
}

.o_kanban_view.o_kanban_ungrouped .o_kanban_record {
    -ms-flex: 1 1 auto;
    -moz-flex: 1 1 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 300px;
    margin: 4px 8px;
}

@media (max-width: 767px) {
    .o_kanban_view.o_kanban_ungrouped .o_kanban_record {
        margin: 0 0 -1px 0;
        -ms-flex: 1 0 100%;
        -moz-flex: 1 0 100%;
        -webkit-box-flex: 1;
        -webkit-flex: 1 0 100%;
        flex: 1 0 100%;
    }
}

.o_kanban_view.o_kanban_ungrouped .o_kanban_record.o_kanban_ghost {
    height: 0;
    min-height: 0!important;
    visibility: hidden;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
}

.o_kanban_view.o_kanban_nocontent {
    min-height: 0;
    padding: 0;
}

.o_kanban_view.o_kanban_mobile .o_kanban_record div.label {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
}

.o_kanban_view .oe_kanban_color_1::after {
    background-color: #F06050;
}

.o_kanban_view .oe_kanban_color_2::after {
    background-color: #F4A460;
}

.o_kanban_view .oe_kanban_color_3::after {
    background-color: #F7CD1F;
}

.o_kanban_view .oe_kanban_color_4::after {
    background-color: #6CC1ED;
}

.o_kanban_view .oe_kanban_color_5::after {
    background-color: #814968;
}

.o_kanban_view .oe_kanban_color_6::after {
    background-color: #EB7E7F;
}

.o_kanban_view .oe_kanban_color_7::after {
    background-color: #2C8397;
}

.o_kanban_view .oe_kanban_color_8::after {
    background-color: #475577;
}

.o_kanban_view .oe_kanban_color_9::after {
    background-color: #D6145F;
}

.o_kanban_view .oe_kanban_color_10::after {
    background-color: #30C381;
}

.o_kanban_view .oe_kanban_color_11::after {
    background-color: #9365B8;
}

/* Kanban Dashboard */
.o_kanban_view.o_kanban_dashboard {
    -ms-flex-flow: row wrap;
    -moz-flex-flow: row wrap;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record {
    position: relative;
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -ms-flex-flow: column nowrap;
    -moz-flex-flow: column nowrap;
    -webkit-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    padding: 7.5px 15px;
}

@media (max-width: 767px) {
    .o_kanban_view.o_kanban_dashboard .o_kanban_record {
        margin-bottom: 10px;
    }
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .container {
    width: 100%;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_manage_toggle_button {
    margin: -1px -1px auto auto;
    padding: 7.5px 15px;
    border: 1px solid transparent;
    border-bottom: none;
    vertical-align: top;
    color: #666;
    height: 35px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_manage_toggle_button:hover {
    color: inherit;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_manage_toggle_button:focus,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_manage_toggle_button:active,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_manage_toggle_button:focus:active {
    outline: none;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane {
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 13px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    box-shadow: 0 6px 12px -4px rgba(0, 0, 0, 0.25);
    position: absolute;
    top: auto;
    left: auto;
    bottom: auto;
    right: -1px;
    margin-top: -1px;
    border-color: #d9d7d7;
    top: 34px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.pull-right {
    right: 0;
    left: auto;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane .divider {
    height: 1px;
    margin: 8px 0;
    overflow: hidden;
    background-color: #e5e5e5;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857143;
    color: #666;
    white-space: nowrap;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane .o_inline_dropdown {
    position: relative;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane .o_inline_dropdown > .dropdown-menu {
    top: 0;
    left: 100%;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane .o_inline_dropdown:hover > .dropdown-menu {
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > div:not(.o_project_kanban_colorpicker) {
    padding: 3px 0 3px 20px;
    visibility: visible;
    margin-bottom: 5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > .o_kanban_card_manage_section {
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 10px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > .o_kanban_card_manage_section > div {
    padding: 0;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > .o_kanban_card_manage_section > div > a {
    margin: auto auto auto -20px;
    padding: 3px 20px;
    color: #666;
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > .o_kanban_card_manage_section > div > a:hover {
    background-color: #E5E5E5;
    color: inherit;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane > .o_kanban_card_manage_section > div:last-child {
    margin-bottom: 5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container {
    width: 95%;
    max-width: 400px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row {
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -ms-flex-flow: row nowrap;
    -moz-flex-flow: row nowrap;
    -webkit-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    margin-left: 0;
    margin-right: 0;
    padding-left: 10px;
    padding-right: 10px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] {
    -ms-flex: 1 1 3333.33333333%;
    -moz-flex: 1 1 3333.33333333%;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 3333.33333333%;
    flex: 1 1 3333.33333333%;
    padding-left: 5px;
    padding-right: 5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > .o_kanban_card_manage_title {
    font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
    line-height: 1.1;
    color: inherit;
    margin-top: 9px;
    margin-bottom: 9px;
    font-size: 13px;
    font-weight: 500;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > .o_kanban_card_manage_title small,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > .o_kanban_card_manage_title .small {
    font-weight: normal;
    line-height: 1;
    color: #AEA79F;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > .o_kanban_card_manage_title small,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > .o_kanban_card_manage_title .small {
    font-size: 75%;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > div:not(.o_kanban_card_manage_title) {
    padding: 0;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > div:not(.o_kanban_card_manage_title) > a {
    margin: auto auto auto -5px;
    padding: 3px 5px;
    color: #666;
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > div:not(.o_kanban_card_manage_title) > a:hover {
    background-color: #E5E5E5;
    color: inherit;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container div[class*="col-"] > div:not(.o_kanban_card_manage_title):last-child {
    margin-bottom: 5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings {
    border-top: 1px solid #E5E5E5;
    padding-top: 15px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings .oe_kanban_colorpicker {
    max-width: none;
    padding: 0;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div[class*="col-"] + div[class*="col-"] {
    border-left: 1px solid #E5E5E5;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div.text-right {
    text-align: left;
    padding: 0;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div.text-right > a {
    margin: auto auto auto 0;
    padding: 3px 0;
    color: #666;
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div.text-right > a:hover {
    background-color: #E5E5E5;
    color: inherit;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div.text-right:last-child {
    margin-bottom: 5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_manage_pane.container .row.o_kanban_card_manage_settings div.text-right > a {
    margin-left: 40px;
    padding-left: 20px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record.o_dropdown_open .o_kanban_card_manage_pane {
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record.o_dropdown_open .o_kanban_manage_toggle_button {
    position: relative;
    background: white;
    border-color: #d9d7d7;
    z-index: 1001;
    position: absolute;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_primary {
    padding-right: 30px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header_title .o_primary,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_primary_left .o_primary > span:first-child,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .oe_kanban_content > .o_title > h3 {
    color: inherit;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0;
    display: block;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_primary_left .o_primary > span:nth-child(2) > strong {
    font-weight: 500;
    font-size: 12px;
    color: #AEA79F;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record.o_has_icon .o_primary {
    padding-left: 12px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_content {
    display: inline-block;
    vertical-align: top;
    min-height: 80px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content {
    -ms-flex: 1 0 auto;
    -moz-flex: 1 0 auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 auto;
    flex: 1 0 auto;
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -ms-flex-flow: column nowrap;
    -moz-flex-flow: column nowrap;
    -webkit-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    margin-top: 15px;
    padding-right: 0;
    padding-left: 0;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content::before,
.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content::after {
    content: normal;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content a {
    position: relative;
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content .o_kanban_primary_bottom {
    margin-top: 7.5px;
    margin-bottom: -7.5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_kanban_card_header + .container.o_kanban_card_content .o_kanban_primary_bottom.bottom_block {
    border-top: 1px solid #E5E5E5;
    background-color: #eeeeee;
    padding-top: 7.5px;
    padding-bottom: 7.5px;
}

.o_kanban_view.o_kanban_dashboard .o_kanban_record .o_dashboard_graph {
    overflow: hidden;
    margin: 15px -15px;
}

.o_kanban_view.o_kanban_dashboard .o_favorite,
.o_kanban_view.o_kanban_dashboard .o_kanban_manage_toggle_button {
    position: absolute;
    top: 0;
    left: auto;
    bottom: auto;
    right: 0;
    padding: 8px;
}

.o_kanban_view.o_kanban_dashboard .o_favorite {
    top: 3px;
    left: 0;
    right: auto;
}

.o_kanban_view.o_kanban_dashboard.o_emphasize_colors .o_kanban_record::after {
    width: 6px;
}

/* Kanban View Mobile */
@media (max-width: 767px) {
    .o_kanban_view.o_kanban_grouped {
        display: block;
        position: relative;
        overflow: hidden;
    }
    .o_kanban_view.o_kanban_grouped .o_kanban_mobile_tabs {
        height: 40px;
        position: relative;
        background-color: #5E5E5E;
    }
    .o_kanban_view.o_kanban_grouped .o_kanban_mobile_tabs .o_kanban_mobile_tab {
        position: absolute;
        top: auto;
        left: 100%;
        bottom: auto;
        right: auto;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        transform: translateX(-50%);
        height: 40px;
        padding: 10px;
        font-size: 14px;
        color: white;
    }
    .o_kanban_view.o_kanban_grouped .o_kanban_mobile_tabs .o_kanban_mobile_tab.o_current {
        font-weight: bold;
        border-bottom: 3px solid #337AB7;
    }
    .o_kanban_view.o_kanban_grouped .o_kanban_mobile_tabs .o_kanban_mobile_tab .o_column_title {
        white-space: nowrap;
    }
    .o_kanban_view.o_kanban_grouped[class] .o_kanban_group:not(.o_column_folded) {
        position: absolute;
        top: 40px;
        left: 0;
        bottom: 0;
        right: auto;
        overflow-x: scroll;
        width: 100%;
        padding: 0;
        margin-left: 0;
        border: none;
    }
    .o_kanban_view.o_kanban_grouped[class] .o_kanban_group:not(.o_column_folded) .o_kanban_header {
        display: none;
    }
    .o_kanban_view.o_kanban_grouped[class] .o_kanban_group:not(.o_column_folded) .o_kanban_record,
    .o_kanban_view.o_kanban_grouped[class] .o_kanban_group:not(.o_column_folded) .o_kanban_quick_create {
        border: none;
        border-bottom: 1px solid lightgray;
        padding: 10px 16px;
        margin: 0;
    }
}

/* POS Dashboard */
.o_kanban_view.o_kanban_dashboard.o_pos_kanban.o_kanban_ungrouped .o_kanban_record {
    width: 500px;
}
</style>

<!--
        <div class="o_kanban_record">
          <div class="o_kanban_card_header">
              <div class="o_kanban_card_header_title mb16">
                  <div class="o_primary">
                    Main
                  </div>                                                      
                  <div class="label label-info o_kanban_inline_block">Closing Control</div>                                    
                  <div class="o_secondary mt16">Administrator</div>
              </div>
              <div class="o_kanban_manage_button_section">
                <a class="o_kanban_manage_toggle_button" href="#"><i class="icon ion-more"></i></a>
              </div>
          </div>
          <div class="container o_kanban_card_content">
            <div class="row">
              <div class="col-xs-6 o_kanban_primary_left">                                                                              
                <button class="btn btn-default oe_kanban_action oe_kanban_action_button" data-name="open_existing_session_cb" data-type="object" type="button">Close</button>                                        
              </div>
              <div class="col-xs-6 o_kanban_primary_right">
                <div class="row">
                  <div class="col-xs-6">
                    <span>Last Closing Date</span>
                  </div>
                  <div class="col-xs-6">
                    <span>10/30/2019</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-6">
                    <span>Cash Balance</span>
                  </div>
                  <div class="col-xs-6">
                    <span><span class="o_field_monetary o_field_number o_field_widget" name="last_session_closing_cash">Rp&nbsp;0.00</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
-->



// WEBPACK FOOTER //
// POSDashboard.vue?2456e55b